export const LOCAL_STORAGE_KEY = 'BUDGET_PERFORMANCE';
export const PERIOD_KEY = 'MonthNumber';
